<template>
	<f7-page name="ccm-matchbook-add-pop" class="page-bg-render">
		<f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">{{getTitle()}}</div>
			<f7-nav-right>
        <f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
      </f7-nav-right>
    </f7-navbar>

		<f7-block-title>
			<span class="text-color-red vertical-align-middle"><i class="f7-icons">equal_square_fill</i></span>
			<span class="vertical-align-middle">매칭북 학습 설정</span>		
		</f7-block-title>

		<div class="list">
			<ul>
				<li>
					<div class="item-content item-input">
						<div class="item-inner">					
							<button class="button button-fill color-red" v-on:click="removeMatchBook" style="width: unset; display: inline-block;">매칭북 등록 해제</button>
						</div>
					</div>
				</li>
				<li class="row text-align-center">
					<div class="col">
						<small class="display-block">시작 페이지</small>
						<div ref="startPageNo" @stepper:change="onChangeStepper" class="stepper stepper-small stepper-fill stepper-init" data-wraps="false" data-autorepeat="true" data-autorepeat-dynamic="true">
							<div class="stepper-button-minus"></div>
							<div class="stepper-input-wrap">
								<input type="text" :value="startPageNo" min="1" max="500" step="1">
							</div>
							<div class="stepper-button-plus"></div>
						</div>
					</div>
					<div class="col">
						<small class="display-block">시작 번호</small>
						<div ref="startExamNo" @stepper:change="onChangeStepper" class="stepper stepper-small stepper-fill stepper-init" data-wraps="false" data-autorepeat="true" data-autorepeat-dynamic="true">
							<div class="stepper-button-minus"></div>
							<div class="stepper-input-wrap">
								<input type="text" :value="startExamNo" min="1" max="2000" step="1">
							</div>
							<div class="stepper-button-plus"></div>
						</div>
					</div>
				</li>
				<li class="row text-align-center padding-bottom">
					<div class="col">
						<small class="display-block">끝 페이지</small>
						<div ref="endPageNo" @stepper:change="onChangeStepper" class="stepper stepper-small stepper-fill stepper-init" data-wraps="false" data-autorepeat="true" data-autorepeat-dynamic="true">
							<div class="stepper-button-minus"></div>
							<div class="stepper-input-wrap">
								<input type="text" :value="endPageNo" min="1" max="500" step="1">
							</div>
							<div class="stepper-button-plus"></div>
						</div>
					</div>
					<div class="col">
						<small class="display-block">끝 번호</small>
						<div ref="endExamNo" @stepper:change="onChangeStepper" class="stepper stepper-small stepper-fill stepper-init" data-wraps="false" data-autorepeat="true" data-autorepeat-dynamic="true">
							<div class="stepper-button-minus"></div>
							<div class="stepper-input-wrap">
								<input type="text" :value="endExamNo" min="1" max="100" step="1">
							</div>
							<div class="stepper-button-plus"></div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="text-align-center">
			<button class="button button-fill" v-on:click="startMatchBookApplyButtonClick" style="width: unset; display: inline-block;">매칭북 문제풀이 시작</button>
		</div>
		<!--
		<div class="block" style="height:var(--f7-toolbar-height);">&nbsp;</div>
		-->
		<f7-block-title>
			<span class="text-color-red vertical-align-middle"><i class="f7-icons">doc_richtext</i></span>
			<span class="vertical-align-middle">매칭북 학습 결과</span>	
		</f7-block-title>

		<div class="list">
			<ul>
				<template v-for="(item, i) in studyResultList">
					<li :key="'ii' + i">
						<a href="#" class="item-link" v-on:click="matchBookResultClick(i);">
							<div class="item-content item-inner">
								<div class="item-title">
									<div class="item-header">
										{{displaySubmitTime(item.SUBMIT_DATETIME)}}					
									</div>
									[{{item.SUB_P1}}P {{item.SUB_E1}}번 ~ {{item.SUB_P2}}P {{item.SUB_E2}}번](총{{item.TOTAL_ITEM_CNT}}문제)
									(맞춘문제 : {{item.CORRECT_ITEM_CNT}} 틀린문제 : {{item.TOTAL_ITEM_CNT-item.CORRECT_ITEM_CNT}})
								</div>
								<div class="item-after">
									<span class="badge">결과보기</span>
								</div>
							</div>
						</a>
					</li>
				</template>
			</ul>
		</div>
		
	</f7-page>
</template>

<script>
 	import Vue from 'vue';
 	import { f7 } from 'framework7-vue';
	import MODULE from '../../../../js/common/module';
	import AUTH from '../../../../js/common/auth.js';
	import PAGES from '../../../../js/pages';
	import API from '../../../../js/common/api.js';
	import CONST from '../../../../js/common/constant';

	export default {
		data() {
			return {				
				matchBookCode: "",
				matchBookName: "",
				matchBookKey: 0,
				startPageNo: 1,
        startExamNo: 1,
        endPageNo: 1,
				endExamNo: 1,
				studyResultList: []
			}
		},
		mounted() {
			const _this = this;			
			_this.matchBookName = _this.$f7route.context.matchBookName;
			_this.matchBookKey = _this.$f7route.context.matchBookKey;			
			_this.matchBookCode = _this.$f7route.context.matchBookCode;	
			_this.startPageNo = _this.$f7route.context.startPageNo;
			_this.endPageNo = _this.$f7route.context.endPageNo;
			_this.startExamNo = _this.$f7route.context.startExamNo;
			_this.endExamNo = _this.$f7route.context.endExamNo;

			if(_this.startPageNo == 0){
				_this.startPageNo = 1;
			}else {
				_this.startPageNo = _this.endPageNo;
			} 

			if(_this.startExamNo == 0){
				_this.startExamNo = 1;
			}else{
				_this.startExamNo = _this.endExamNo;
			}

			if(_this.endPageNo == 0){
				_this.endPageNo = 1;
			}

			if(_this.endExamNo == 0){
				_this.endExamNo = 1;
			}
			
			_this.loadMyMatchBookResultList();

			$(document).on('page:reinit', '.page[data-name="ccm-matchbook-add-pop"]', _this.loadMyMatchBookResultList);			
		},
		methods: {
			
			displaySubmitTime(submitTime) {
				var formatDate = moment(submitTime).format("YY.MM.DD");			
				return formatDate;
			},
			matchBookResultClick(itemIndex) {
				const _this =this;
				var item = _this.studyResultList[itemIndex];

				if(MODULE.Util.isEmpty(item.STUDY_KEY)) {
					MODULE.DialogBox.message("에러", "학습결과에 필요한 데이타가 없습니다.");
					return;
				}
				
				var url = PAGES.SUB_CCM_MATCHBOOK_APPLY;
				var param = {
					studyType : item.STUDY_TYPE,
					code : _this.matchBookCode,
					studyKey: item.STUDY_KEY,
					startPageNo: item.SUB_P1,
					startExamNo: item.SUB_E1,
					endPageNo: item.SUB_P2,				
					endExamNo: item.SUB_E2
				};
		
				PAGES.popPage(url, param);

			},
			onChangeStepper() {
				const _this = this;

				const stepperStartPageNo = _this.$refs.startPageNo.f7Stepper;
				const stepperStartExamNo = _this.$refs.startExamNo.f7Stepper;
				const stepperEndPageNo = _this.$refs.endPageNo.f7Stepper;
				const stepperEndExamNo = _this.$refs.endExamNo.f7Stepper;

				if (stepperStartPageNo.value == stepperEndPageNo.value) {
					if (stepperEndExamNo.value < stepperStartExamNo.value) {
						stepperEndExamNo.setValue(stepperStartExamNo.value);
					}
				} else if (stepperStartPageNo.value > stepperEndPageNo.value) {
					stepperEndPageNo.setValue(stepperStartPageNo.value);
					stepperEndExamNo.setValue(stepperStartExamNo.value);
				}

				_this.startPageNo = stepperStartPageNo.value;
				_this.startExamNo = stepperStartExamNo.value;
				_this.endPageNo = stepperEndPageNo.value;
				_this.endExamNo = stepperEndExamNo.value;
			},	
			getTitle() {
				const _this = this;
				var popTitle = _this.matchBookName + "(" +_this.matchBookCode+ ")";
				return popTitle;

			},
			startMatchBookApplyButtonClick() {
				const _this = this;
				var startPageNo = _this.startPageNo;
				var startExamNo = _this.startExamNo;
				var endPageNo = _this.endPageNo;
				var endExamNo = _this.endExamNo;

				if (
					(startPageNo == endPageNo && startExamNo <= endExamNo) ||
					(startPageNo < endPageNo)
				) {

					//this.selectedMatchBookData.sheet.close();

					var url = PAGES.SUB_CCM_MATCHBOOK_APPLY;
					var param = {
						code: _this.matchBookCode,
						startPageNo: _this.startPageNo,
						startExamNo: _this.startExamNo,
						endPageNo: _this.endPageNo,
						endExamNo: _this.endExamNo,
						studyType: CONST.studyType["mb-sdy"].id
					}
					PAGES.popPage(url, param);
      	}
			},
			removeMatchBook() {
				const _this = this;

				var message = "매칭북 : " + _this.matchBookName + " 를 등록 해제 할까요 ?";

				if( _this.matchBookKey == 0){
					MODULE.DialogBox.message("에러","삭제에 필요한 데이타가 없습니다.");
					return;
				}

				MODULE.DialogBox.okcancel(
					"등록 해제 확인", message,  
					function() {
						
						var url = PAGES.MENU_CCM_MATCHBOOK_STUDY;
						
						let param = {							
							pMatchBookKey : _this.matchBookKey
						};						
		
						API.ajaxRequest({
							url: API.removeMyMatchBook(),
							data: param
						}).then(function(data) {
							PAGES.back(url);   
						}).catch(function(code) {
							MODULE.UITool.catchBlock(code, PAGES, AUTH);
						});
					}
				);

			},
			loadMyMatchBookResultList() {
				const _this = this;

				let param = {					
					pMatchBookKey: _this.matchBookKey
				};

				API.ajaxRequest({
					url: API.getMyMatchBookResultList(),
					data: param
				}).then(function(data) {
					_this.studyResultList = data.studyResultList;
				}).catch(function(code) {
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			}
	
		}

		
	}
</script>